export default __webpack_public_path__ + "static/simple-bar-ffaedc35b0057257efd89a02a313f80c.png";